import apiHandler from "../core/apiHandler";

const userPermissionOverridesApi = apiHandler('user-permissions');
export default userPermissionOverridesApi;
